import { createStyles, type StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    justifyContent: 'space-between',
    marginTop: '32px',
    gap: '32px',
  },
  bussinessCardWrapper: {
    padding: '0px',
    flexBasis: '33.33%',
  },
  cardImage: {
    minHeight: '300px',
  },
})

export default styles

export type StylesClassNames = StylesClasses<typeof styles>
